import { axiosGet } from '@/api/AxiosApi';

export const bannerList = async () => {
  const paylaod = {
    path: '/v1/board/banner/list',
  };
  const { data: re } = await axiosGet(paylaod);
  return re;
};
